import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function CheckIcon({ classes }) {
  const styles = useStyles();
  const iconClasses = cn(styles.checkIcon, classes);

  return (
    <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" width="289.484" height="289.484" viewBox="0 0 289.484 289.484">
      <g id="Group_8669" data-name="Group 8669" transform="translate(-0.002 0)">
        <g className={styles.checkIconG} id="Ellipse_1503" data-name="Ellipse 1503" transform="translate(0.001 0)" fill="none" strokeWidth="15">
          <ellipse cx="144.742" cy="144.742" rx="144.742" ry="144.742" stroke="none" />
          <ellipse cx="144.742" cy="144.742" rx="137.242" ry="137.242" fill="none" />
        </g>
        <path
          className={styles.checkIconPath}
          id="Checkbox"
          d="M51.617,95.371,1,44.754,13.011,32.743,51.617,70.491,121.108,1l12.011,12.011Z"
          transform="translate(77.403 96.701)"
        />
      </g>
    </svg>
  );
}

CheckIcon.propTypes = {
  classes: PropTypes.string,
};

CheckIcon.defaultProps = {
  classes: '',
};

export default CheckIcon;
